import React from 'react'
import PropTypes from 'prop-types'

import OrderPointsAndCashDonation from './OrderPointsAndCashDonation'
import OrderInfoDonation from './OrderInfoDonation'
import { About } from '../About'

const AboutOrderDonation = props => (
  <About title=' Sobre o pedido'>
    <OrderPointsAndCashDonation
      paymentDetailMoneyAndPoints={
        props.parentOrder.OrderPointsAndCashDonation
      }
    />
    <OrderInfoDonation parentOrder={props.parentOrder} />
  </About>
)

AboutOrderDonation.propTypes = {
  parentOrder: PropTypes.object
}

export default AboutOrderDonation



// WEBPACK FOOTER //
// ./src/features/AboutOrderDonation/AboutOrderDonation.js